import { render, staticRenderFns } from "./View.vue?vue&type=template&id=759b66a8&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=759b66a8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759b66a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('759b66a8')) {
      api.createRecord('759b66a8', component.options)
    } else {
      api.reload('759b66a8', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=759b66a8&scoped=true", function () {
      api.rerender('759b66a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/Callout/View.vue"
export default component.exports